module.exports = __webpack_public_path__ + "img/audrey.9887de05.jpg";